import {NumberInput} from '@mantine/core'
import {useState} from 'react'

type CoordinateInputProps = {
    value: number | null
    onChange: (value: number | null) => void
    label: string
}

function parseCoordinate(value: number | string): number | null {
    const text = String(value).trim()
    if (!text) {
        return null
    }

    const parsed = Number(text)
    return Number.isFinite(parsed) ? parsed : null
}

export function CoordinateInput({value, onChange, label}: CoordinateInputProps) {
    const [displayValue, setDisplayValue] = useState<number | string>(value ?? '')
    const [previousValue, setPreviousValue] = useState(value)

    if (value !== previousValue) {
        setPreviousValue(value)

        // Preserve in-progress text when this prop change came from this field's own edit.
        if (parseCoordinate(displayValue) !== value) {
            setDisplayValue(value ?? '')
        }
    }

    return (
        <NumberInput
            label={label}
            decimalScale={6}
            hideControls
            value={displayValue}
            onChange={(nextValue) => {
                setDisplayValue(nextValue)
                onChange(parseCoordinate(nextValue))
            }}
        />
    )
}
